// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"562":"intl-messages1","945":"intl-messages0","981":"intl-messages2"}[chunkId] || chunkId) + "." + {"66":"c87f9574819d14ba","562":"ac81e0b02c7be458","945":"57cad65651acdb03","981":"55240f58892dec0a"}[chunkId] + ".js";
};